import { axiosClient } from "../api/axiosClient";
import type { CurrentMonthIncome } from "../hooks/useCurrentMonthIncomeQuery";

export const incomeRepository = {
  async getCurrentMonth(
    terreiroId?: string,
    mediumId?: string,
    period?: { month: number; year: number },
  ): Promise<CurrentMonthIncome> {
    const params = new URLSearchParams();

    if (period) {
      params.append("month", String(period.month));
      params.append("year", String(period.year));
    } else {
      params.append("period", "current_month");
    }

    if (terreiroId) {
      params.append("terreiroId", terreiroId);
    } else if (mediumId) {
      params.append("mediumId", mediumId);
    }

    const response = await axiosClient.get(`/incoming?${params.toString()}`, {
      withCredentials: true,
    });
    return response.data;
  },
};
